import api from "./core";

const basePath = "api/core/PMP";

export default {
  requestPatient(eocId) {
    return api.get(`${basePath}/RequestPatient/${eocId}`);
  },
  requestReport(eocId, reportUrl) {
    return api.get(`${basePath}/RequestReport/${eocId}?reportUrl=${reportUrl}`);
  }
};
